import React from 'react';
import { Text } from '@sitecore-jss/sitecore-jss-react';
import SwaggerUI from "swagger-ui-react"
import "swagger-ui-react/swagger-ui.css"

const SampleSwaggerDoc = (props) => (
  <div>
    {/* <p>SampleSwaggerDoc Component</p> */}
    {/* <Text field={props.fields.heading} /> */}
    <SwaggerUI url="https://qa1.v2.wemshowcase.com/api/sitecore/json/loadjson?sc_apikey={0BF7C067-4B3F-4AEB-A2CD-61F0A58276B9}" />
  </div>
);

export default SampleSwaggerDoc;
